import gql from "graphql-tag";
export const DISTRIBUTOR_HESA_FRAGMENT = gql`
  fragment distributorHesa on DistributorHesa {
    codigo,
    nombreDistribuidor
  }
`;

export const DISTRIBUTORS_HESA = gql`
  query distibutorsHesa ($anio: Long) {
    DistributorHesa: distributorsHesa(anio: $anio) {
      ...distributorHesa
    }
  }
  ${DISTRIBUTOR_HESA_FRAGMENT}
`;